import type { TranslationKey } from '../i18n/en'
import { PRODUCTION_SPECIES_PRESETS, type ProductionSpeciesKey } from '../data/productionSpeciesPresets'

// Pre-validation #58: the presets in productionSpeciesPresets.ts carry
// English `label`/`description` strings (data, not UI). Screens render the
// translated text through these helpers instead; an unknown key falls back
// to the preset's own text, then to the raw key.

type Translate = (key: TranslationKey, params?: Record<string, string | number>) => string

const isPresetKey = (key: string): key is ProductionSpeciesKey =>
  Object.prototype.hasOwnProperty.call(PRODUCTION_SPECIES_PRESETS, key)

export const getProductionSpeciesLabel = (t: Translate, speciesKey: string): string =>
  isPresetKey(speciesKey) ? t(`species.${speciesKey}.label` as TranslationKey) : speciesKey

export const getProductionSpeciesDescription = (t: Translate, speciesKey: string): string =>
  isPresetKey(speciesKey) ? t(`species.${speciesKey}.description` as TranslationKey) : ''
